import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { CalloutIconWrapper, CalloutLink, CalloutTitle, CalloutWrapper } from './styles';
import { H5 } from '../type';

export type CalloutProps = {
  title: string;
  ctaUrl?: string;
  body: string;
};

export const Callout = ({ title, ctaUrl, body }: CalloutProps) => (
  <CalloutWrapper>
    <CalloutTitle>
      <CalloutIconWrapper>
        <LightbulbOutlinedIcon fontSize="inherit" />
      </CalloutIconWrapper>
      <H5 as="h4">{title}</H5>
    </CalloutTitle>
    <p>{body}</p>
    {ctaUrl && <CalloutLink href={ctaUrl}>Learn more</CalloutLink>}
  </CalloutWrapper>
);
